import {
    useRecordContext,
    useNotify, useDataProvider, useRefresh,
    Button,
} from 'react-admin';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useState } from 'react';
import { Alert } from "@mui/material";
import GroupAddIcon from '@mui/icons-material/GroupAdd';

const CreateUserButton = () => {
    const record = useRecordContext();
    const refresh = useRefresh();
    const notify = useNotify();
    const [isDisabled, setIsDisabled] = useState(false);
    const dataProvider = useDataProvider();
    const Handleclick = async () => {
        setIsDisabled(true);
        dataProvider.showOne(`task/training/createUsers/${record.id}`)
            .then(({ data }) => {
                if (data) {
                    notify(
                        <Alert severity="success">
                            Training users have been created.
                        </Alert>
                    );
                } else {
                    notify(
                        <Alert severity="error">
                            Something went wrong, please try again later.
                        </Alert>
                    );
                }
            })
            .catch((error) => { 
                // Determine the error message to display
                const errorMessage = error.message || 'An error occurred, please try again later.';
            
                // Notify the user with the error message
                notify(
                    <Alert severity="error">
                        {errorMessage}
                    </Alert>
                );
            })
            .finally(() => {
                setIsDisabled(false);
                refresh();
            });
    };

    return (
        <div>
            <Button  startIcon={<GroupAddIcon />} label="Create users in RLAB" onClick={() => Handleclick()} disabled={isDisabled} />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isDisabled}
            >
                <CircularProgress color="secondary" />
            </Backdrop>
        </div>
    )
}
export default CreateUserButton;
